/**
 * Handles error extraction from error object
 * @param {Object} error Error object from API
 * @returns {String} Error string
 */
export const getError = (error) => {
  if (!error.nonFieldErrors) return 'There was an error with your request';
  return error.nonFieldErrors[0];
};
